import React, { ReactNode } from "react"
import Head from "next/head"
import Image from "next/image"
import { LogoUrl } from "../../libs/vars/url"
import { useCheck } from "../../hooks/useUser"
import { DefaultSiteName } from "../../libs/vars/system"

type Props = {
  children?: ReactNode
  title?: string
}

export default function LayoutAuth({ children = null, title = "" }: Props) {
  // here we just check if user is already logged in and redirect to profile
  const { data } = useCheck({ isAuthPage: true, isNeedRedirect: true })

  if (!data || data?.isLoggedIn) {
    return <p>Загрузка...</p>
  }

  return (
    <>
      <Head>
        <title>
          {title ? title + " | " + DefaultSiteName : DefaultSiteName}
        </title>
        <meta charSet="utf-8" />
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
      </Head>

      <div className="flex min-h-full items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div className="overflow-hidden shadow sm:rounded-md">
            <div className="bg-white px-4 py-5 sm:p-6">
              <div className={"text-center"}>
                <Image
                  className="mx-auto h-12 w-auto"
                  src={LogoUrl}
                  alt="Workflow"
                  width={48}
                  height={48}
                />
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                  {title}
                </h2>
              </div>

              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
